module.exports = __webpack_public_path__ + "img/tab3.d47cc273.png";